import React from 'react';

import { useBreakpoint } from '@/hooks/useBreakpoint';

import { careersHeaderPropTypes } from './careersHeaderPropTypes';
import { DesktopHeader } from './components/DesktopHeader';
import { MobileHeader } from './components/MobileHeader';
import { CareersHeaderProvider } from './contexts/CareersHeaderContext';

/**
 *
 * The Header component is a wrapper for the MobileHeader and DesktopHeader components. It determines which header to render based on the current breakpoint and is a Global component.
 */
const CareersHeader = ({ coveo, searchResultsPage, ...props }) => {
    const breakpoint = useBreakpoint();
    const isMobile = !breakpoint?.largeplus;
    return (
        <CareersHeaderProvider coveo={coveo} searchResultsPage={searchResultsPage}>
            <MobileHeader {...props} isActive={isMobile} />
            <DesktopHeader {...props} isActive={!isMobile} />
            {props.alertBannerComponent || null}
        </CareersHeaderProvider>
    );
};

CareersHeader.propTypes = {
    ...careersHeaderPropTypes,
};

export default CareersHeader;
